export const styles = {
  mobileWrapper: {
    borderRadius: "48px",
    border: "12px solid #000",
    height: "70vh",
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  previewContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 2,

    "@media (max-width: 1100px)": {
      flexDirection: "column",
      alignItems: "center",
    },
  },
};
